import { CombinedGraphQLErrors } from '@apollo/client/errors';

/**
 * The business code the API refused with, or null when the failure is not one of its
 * refusals: a transport error, or a code we have never seen.
 *
 * It lives here rather than beside one screen's readings because **how a refusal is
 * read off an Apollo error is one fact, and the readings are many**: the accounts
 * screen names its own codes, the onboarding journey names its own, and both ask the
 * same question first. A second copy of this function is a second answer to « what
 * counts as a business refusal », and the day the API adds an `extensions` envelope
 * only one of the copies would learn about it.
 *
 * Attention, only the **first** error is read. The mutations of this app resolve a single
 * field, so a second entry is a second failure of the same call rather than a second
 * refusal to render, and a screen showing two refusals for one gesture reads as two
 * gestures having failed.
 */
export const refusalCode = (error: unknown): string | null => {
    if (!CombinedGraphQLErrors.is(error)) {
        return null;
    }
    const code = error.errors[0]?.extensions?.code;
    return typeof code === 'string' ? code : null;
};
